import React from 'react';
import PropTypes from 'prop-types';
import { Element } from 'react-scroll';
import CategoryItem from './CategoryItem';

const RoomItem = ({
 id, name, categories, isLastItem,
}) => (
  <Element className="room-item" id={id}>
    <div className="room-title-container">
      <div className="room-title">{name}</div>
      <div className="divider-bottom" />
    </div>
    <div className="container-categories">
      {categories.map((category, index) => (
        <CategoryItem
          category={category}
          roomId={id}
          isLastItem={isLastItem && category.id === categories[categories.length - 1].id}
          order={index}
          disabled={category.disabled}
        />
        ))}
    </div>
  </Element>
);

RoomItem.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  categories: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    disabled: PropTypes.bool,
    cameras: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string,
      roomId: PropTypes.string,
      isPriority: PropTypes.bool,
    })),
    selected_feature: PropTypes.string,
    features: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      description: PropTypes.string,
      thumb: PropTypes.string,
      order: PropTypes.number,
      disabled: PropTypes.bool,
    })),
  })).isRequired,
  isLastItem: PropTypes.bool.isRequired,
};

export default RoomItem;
